import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/sites/siteCardView.css';

const SiteGridViewData = React.memo(({ index, style, data }) => {

    const { sites, columns, filteredSitesCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredSitesCount);

    const handleSiteClick = useCallback((siteId) => navigate(`site_details/${siteId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const siteIndex = startIndex + idx;
                const site = sites[siteIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={site ? site.id : `skeleton-${siteIndex}`}>
                        <Card className='sites_gridview_card'>
                            <CardActionArea onClick={site ? () => handleSiteClick(site.id) : undefined}>
                                {site ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(site, 'site', { size: 'small', fallback: machineDefaultImage })}
                                            alt={site.name}
                                        />
                                        <CardContent className='sites_gridview_card_CardContent'>
                                            <Typography className='sites_gridview_site_name' component="div">{site?.name}</Typography>
                                            <Typography className='sites_gridview_site_adress' component="div">{site?.address}</Typography>
                                            <Typography className='sites_gridview_site_adress' component="div">{site?.postal_code}</Typography>
                                            <Typography className='sites_gridview_site_adress' component="div">{site?.city}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default SiteGridViewData;